// eslint-disable-next-line @typescript-eslint/naming-convention
import jwt_decode from 'jwt-decode';

type Epoc = number;

export enum TokenLinkType {
  AccountSignUp = 'ACCOUNT_SIGNUP',
  AccountForgot = 'ACCOUNT_FORGOT',
  AccountInvitation = 'ACCOUNT_INVITATION',
  ForgotPassword = 'FORGOT_PASSWORD',
}

export enum PermissionType {
  UserOtp = 'USER:OTP',
}

type ActionType =
  | 'MARK_TODO'
  | 'MARK_IN_PROGRESS'
  | 'MARK_COMPLETED'
  | 'MARK_BLOCKED'
  | 'APPROVE_REQUEST';

type Scope = PermissionType.UserOtp | `TASK:${ActionType}`;

interface Decoded {
  accountId: number;
  emailId: string;
  exp: Epoc;
  iat: Epoc;
  iss: 'rocketlane.com';
  jti: string;
  linkType: TokenLinkType;
  permission: PermissionType;
  scopes: Scope[];
}

interface DecodedExtended extends Decoded {
  email?: string;
  name?: string;
}

const getDecodedValue = (token: string) => {
  try {
    return jwt_decode<DecodedExtended>(token);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};

type TokenMeta = {
  decoded: DecodedExtended | null;
  isExpired: boolean;
};

export const getTokenMeta = (token: string): TokenMeta => {
  const decoded: DecodedExtended | null = getDecodedValue(token);

  const isExpired = decoded
    ? new Date(decoded?.exp * 1000) < new Date()
    : false;

  return { decoded, isExpired };
};
